body {
  margin: 0;
  font-family: sans-serif;
  background-color: #f7f7f7;
}
  
.title {
  color: rgb(255, 0, 0);
  text-align: center;
  margin-top: 50px;
  font-size: 2rem;
}

.my-bg-head {
	background-color: rgb(255, 166, 0);
}

.my-bg-menu {
	background-color: rgb(255, 166, 0) !important;
}

.my-bg-column {
	background-color: rgb(255, 166, 0) !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}
